import { prop } from '@ipfabric/utils/fp/prop';
import { flow } from 'fp-ts/lib/function';
import type React from 'react';

/**
 * @example
 * declare const showMessage: (m: string) => void;
 *
 * <input type="text" onChange={withTargetValue(showMessage)}>
 */
export const withTargetValue: (
  callback: (value: string) => void,
) => (e: React.ChangeEvent<{ value: string }>) => void = (callback) =>
  flow(prop('target', 'value'), callback);
